export const SUPPORT_ASSESSMENT_TOOLS = "/api/support_assessment_tools"
export const SUPPORT_ASSESSMENT_TOOL = "/api/support_assessment_tools/:param"
export const SUPPORT_ASSESSMENT_TOOL_ACTIVATE = "/api/support_assessment_tools/:param/activate"
export const SUPPORT_ASSESSMENT_TOOL_DEACTIVATE = "/api/support_assessment_tools/:param/deactivate"
export const EXPORT_SUPPORT_ASSESSMENT_TOOL = "/api/support_assessment_tools/export"
export const IMPORT_SUPPORT_ASSESSMENT_TOOL = "/api/support_assessment_tools/import"
